import { SDKCollection } from './core/collection.js';
import Transport from './core/transport.js';
import { AuthModel } from './models/auth.js';
import { CollectionModel, Collections } from './models/collections.js';
import { ComponentModel, Components } from './models/components.js';
import { ContentHubOneDatasources, DatasourceModel, Datasources, XmDatasources } from './models/datasources.js';
import { ContentHubOneContentTypeModel } from './models/external/content-hub-one-content-types.js';
import { ExternalComponentModel } from './models/external/external-components.js';
import { FormModel, Forms } from './models/external/forms.js';
import { TenantModel, Tenants } from './models/external/tenants.js';
import { XmTemplateModel } from './models/external/xm-templates.js';
import { Libraries, LibraryModel, TemplateLibraries } from './models/libraries.js';
import { StylesheetModel, Stylesheets } from './models/stylesheets.js';
import { VersionBundleModel, VersionBundles } from './models/version-bundles.js';
import { VersionModel, Versions } from './models/versions.js';
import * as Style from './style/index.js';
import * as CSS from './utils/css.js';
import * as utils from './utils/index.js';
import { RenderingHostModel } from './models/external/rendering-host.js';
export * from './style/embed.js';
export * from './utils/index.js';
export { Style, CSS };
// Create subclass that hassdk property defined]
function assignApi(Base, sdk) {
    const Subclass = class extends Base {
        constructor(...args) {
            super(...args);
        }
    };
    Object.defineProperty(Subclass.prototype, 'sdk', {
        enumerable: false,
        writable: true,
        value: sdk
    });
    Object.defineProperty(Subclass.prototype, Symbol.toStringTag, {
        value: Base.name
    });
    return Subclass;
}
class SDK extends Transport {
    constructor() {
        super(...arguments);
        this.Libraries = new Libraries(this);
        this.Collections = new Collections(this);
        this.Components = new Components(this);
        this.Tenants = new Tenants(this);
        this.Versions = new Versions(this);
        this.VersionBundles = new VersionBundles(this);
        this.Stylesheets = new Stylesheets(this);
        this.Datasources = new Datasources(this);
        this.XmDatasources = new XmDatasources(this);
        this.ContentHubOneDatasources = new ContentHubOneDatasources(this);
        this.TemplateLibraries = new TemplateLibraries(this);
        this.Forms = new Forms(this);
        this.Collection = assignApi(CollectionModel, this);
        this.Component = assignApi(ComponentModel, this);
        this.ExternalComponent = assignApi(ExternalComponentModel, this);
        this.Version = assignApi(VersionModel, this);
        this.VersionBundle = assignApi(VersionBundleModel, this);
        this.Library = assignApi(LibraryModel, this);
        this.Stylesheet = assignApi(StylesheetModel, this);
        this.Style = Object.assign(Style.Rule, Style);
        this.Datasource = assignApi(DatasourceModel, this);
        this.Tenant = assignApi(TenantModel, this);
        this.XmTemplate = assignApi(XmTemplateModel, this);
        this.Form = assignApi(FormModel, this);
        this.Auth = assignApi(AuthModel, this);
        this.RenderingHost = assignApi(RenderingHostModel, this);
        this.ContentHubOne = assignApi(ContentHubOneContentTypeModel, this);
        this.libraries = SDKCollection.construct(this.Library, () => ({
        //sdk: this
        }));
        this.templateLibraries = SDKCollection.construct(this.Library, () => ({}));
        this.tenants = SDKCollection.construct(this.Tenant, () => { });
        // combination of internal and external datasources
        this.datasources = SDKCollection.construct(this.Datasource, () => { });
        this.utils = utils;
        this.CSS = CSS;
        this.auth = new this.Auth();
        this.renderingHost = new this.RenderingHost();
    }
    get externalComponents() {
        return this.renderingHost.expandedComponents;
    }
    get externalDatasources() {
        return this.renderingHost.registeredDatasources;
    }
    normalizeHTML(html) {
        return (html
            // sort attributes
            .replace(/<([a-z0-9-]+) ([^>]+?)(\s?\/?)>/g, (m, tag, attrs, closer = '') => {
            const matches = attrs.match(/\b([\w-]+)(?:\s*=\s*("[^"]*"|'[^']*'|[^'">\s]+))?/g);
            if (!matches)
                return m;
            matches.sort();
            return '<' + tag + ' ' + matches.join(' ') + closer + '>';
        })
            // remove extra whitespace
            .replace(/>\s+</g, '><')
            .trim());
    }
    getFrontendURL(target) {
        const contextQuery = this.getContextQuery();
        const path = typeof target == 'string' ? target : target.getPath();
        return `${this.frontend}${path}${contextQuery ? '?' + contextQuery : ''}`;
    }
    getContextQuery() {
        return this.auth.tenant ? new URLSearchParams(this.auth.tenant.getContext()).toString() : '';
    }
    getBackendURL(model) {
        return this.backend + '/' + model.getPath();
    }
}
SDK.Library = LibraryModel;
SDK.Collection = CollectionModel;
SDK.Component = ComponentModel;
SDK.ExternalComponent = ExternalComponentModel;
SDK.Version = VersionModel;
SDK.Stylesheet = StylesheetModel;
SDK.Style = Style;
SDK.Datasource = DatasourceModel;
SDK.Tenant = TenantModel;
SDK.XmTemplate = XmTemplateModel;
export { SDK };
//# sourceMappingURL=sdk.js.map